import { createTheme } from '@mui/material';

export type ThemeMode = 'light' | 'dark';

export const commonTheme: Parameters<typeof createTheme>[0] = {
  typography: {
    fontFamily:
      '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
    h1: {
      fontWeight: 700,
      fontSize: '2.5rem',
      letterSpacing: '-0.025em',
    },
    h2: {
      fontWeight: 600,
      fontSize: '2rem',
      letterSpacing: '-0.025em',
    },
    h3: {
      fontWeight: 600,
      fontSize: '1.5rem',
      letterSpacing: '-0.025em',
    },
    h4: {
      fontWeight: 600,
      fontSize: '1.25rem',
      letterSpacing: '-0.025em',
    },
    h5: {
      fontWeight: 500,
      fontSize: '1.125rem',
      letterSpacing: '-0.025em',
    },
    h6: {
      fontWeight: 500,
      fontSize: '1rem',
      letterSpacing: '-0.025em',
    },
    body1: {
      fontWeight: 400,
      fontSize: '0.9rem',
      letterSpacing: '0.01em',
    },
    subtitle1: {
      fontWeight: 600,
      fontSize: '0.9rem',
      letterSpacing: '0.01em',
    },
    body2: {
      fontWeight: 400,
      fontSize: '0.8rem',
      letterSpacing: '0.01em',
    },
    subtitle2: {
      fontWeight: 600,
      fontSize: '0.8rem',
      letterSpacing: '0.01em',
    },
    caption: {
      fontWeight: 500,
      fontSize: '0.7rem',
      letterSpacing: '0.01em',
    },
    button: {
      fontWeight: 500,
      fontSize: '0.8rem',
      letterSpacing: '0.025em',
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
          borderRadius: 8,
          padding: '8px 16px',
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow:
            '0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06)',
          border: '1px solid rgba(0, 0, 0, 0.05)',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
        },
      },
    },
  },
};
